import { Button, Row, Col } from 'react-bootstrap';
import { useUpdateSlotStatus } from '../../apiEndpoints/b2bBuyerSellerEndpoint';
import { B2BAuthContext } from '../../../../Context/AuthContex/B2BAuthContext';
import { useEffect, useState } from 'react';
import { useExhibitorAuthContext } from '../../../../Context/AuthContex/ExhibitorAuthContext';

const MeetingApprovedReject = ({
  id,
  showApprove,
  showCancelled,
  showRejected,
}: {
  id: number;
  showApprove?: boolean;
  showRejected?: boolean;
  showCancelled?: boolean;
}) => {
  const { mutate, isSuccess } = useUpdateSlotStatus(id);
  const {
    state: { b2bUser },
  } = B2BAuthContext();
  const {
    state: { exhibitorUser },
    dispatch: authDispatch,
  } = useExhibitorAuthContext();
  const [takeReason, setTakeReason] = useState(false);
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (isSuccess) {
      setReason('');
      setTakeReason(!takeReason);
    }
  }, [isSuccess]);
  return (
    <div className='mt-3'>
      <Row>
        {showApprove && !takeReason && (
          <Col
            xs={12}
            lg={12}
            xl={6}
            className='d-flex justify-content-between'
          >
            <Button
              className='w-100'
              variant='success'
              onClick={() =>
                mutate({
                  type: b2bUser.b2b_id ? 'B2B' : 'Exhibitor',
                  user_id: Number(b2bUser.b2b_id)
                    ? Number(b2bUser.b2b_id)
                    : Number(exhibitorUser.user_fair_member_id),
                  status: 'Accepted',
                })
              }
            >
              Approved
            </Button>
          </Col>
        )}

        {showRejected && !takeReason && (
          <Col
            xs={12}
            lg={12}
            xl={6}
            className='d-flex justify-content-between'
          >
            <Button
              onClick={() => setTakeReason(!takeReason)}
              className='w-100'
              variant='danger'
            >
              Rejected
            </Button>
          </Col>
        )}

        {showCancelled && (
          <Col
            xs={12}
            lg={!showApprove && !showRejected ? 12 : 6}
            className='d-flex justify-content-between'
          >
            <Button
              className='w-100'
              variant='danger'
              onClick={() =>
                mutate({
                  type: b2bUser.b2b_id ? 'B2B' : 'Exhibitor',
                  user_id: Number(b2bUser.b2b_id)
                    ? Number(b2bUser.b2b_id)
                    : Number(exhibitorUser.user_fair_member_id),
                  status: 'Cancelled',
                })
              }
            >
              Cancel Now
            </Button>
          </Col>
        )}

        {/* take reason */}

        {takeReason && (
          <Col xs={12}>
            <Row className=''>
              <Col xs={12} className='p-2'>
                <textarea
                  placeholder='Write Reject Reason'
                  className={`form-control`}
                  onChange={(e) => setReason(e.target.value)}
                />
              </Col>
              <Col xs={12} lg={!showApprove && !showRejected ? 12 : 6}>
                {' '}
                <Button
                  className='w-100'
                  variant='danger'
                  onClick={() => setTakeReason(!takeReason)}
                >
                  Cancel
                </Button>
              </Col>
              <Col xs={12} lg={!showApprove && !showRejected ? 12 : 6}>
                {' '}
                <Button
                  className='w-100'
                  variant='success'
                  onClick={() =>
                    mutate({
                      type: b2bUser.b2b_id ? 'B2B' : 'Exhibitor',
                      user_id: Number(b2bUser.b2b_id)
                        ? Number(b2bUser.b2b_id)
                        : Number(exhibitorUser.user_fair_member_id),
                      status: 'Rejected',
                      rejected_reason: reason,
                    })
                  }
                >
                  Submit
                </Button>
              </Col>
            </Row>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default MeetingApprovedReject;
